var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"access-denied"},[_c('h1',[_vm._v("\n\t\tAccess Denied\n\t\t"),_c('font-awesome-icon',{staticClass:"icon",attrs:{"icon":['fal', 'exclamation-triangle']}})],1),_c('p',{attrs:{"data-test":"access-denied-item"}},[_vm._v("You do not have access to "+_vm._s(_vm.item)+". Please contact your admin.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }